<template>
  <div class="EHR">
    <div class="page_img">
      <img src="@/assets/img/ehr_system.jpg" alt="">
    </div>
    <div class="page_content content flex_row">
      <div class="content_title font_shadow summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="ehr_summary page_summary">电子病历EHR</div>
      </div>
    </div>
    <div class="page_main flex_column main">
      <img src="@/assets/img/ehr_main.png" alt="">
      <div class="main_explain ehr_explain">智能化电子病历实现输入零失误、易查询的数据管理。视觉识别各种格式文档，进行关键信息识别获取。让电子病历的基础数据更安全，更智能化</div>
    </div>
    <div class="page_system flex_column system" v-for="item in list">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">{{item.title}}</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="sys_main1 system_main">
        <img :src="item.src" alt="">
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'EHR',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
      list: []
    }
  },
  created() {
    let list = [
      {
        title: '手机端健康报告',
        src: 'https://www.visumall.com/public/img/ehr_main1.png'
      },
      {
        title: 'IPAD、PC端健康报告',
        src: 'https://www.visumall.com/public/img/ehr.png'
      },
    ]
    this.list = list;
  },
}
</script>

<style scoped lang="scss">
.EHR {
  .content {
    margin-top: 0.4rem;
    .summary_top {
      .ehr_summary {
        font-size: 0.3rem;
      }
    }
  }
  .main {
    margin: 1.5rem 0 1rem;
    img {
      width: 50%;
    }
    .ehr_explain {
      margin: 1rem 0 0;
      width: 65%;
      padding: 0.25rem 0.45rem;
      font-size: 0.18rem;
      font-weight: 500;
    }
  }
  .system {
    margin-bottom: 1rem;
    .system_title {
      .sys_summary {
        font-size: 0.3rem;
        font-weight: bold;
        text-align: center;
      }
    }
    .system_main {
      margin-top: 0.8rem;
      img {
        width: 55%;
      }
    }
  }

}
</style>
